import React from "react";

//MUI
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";

import Divider from "../../Divider";

import { useAppSelector } from "../../../redux/hooks/redux-hooks";
import { isValidArr } from "../../../utility/utils";

const CustomerPOCInfoSection = () => {
  const projectCustomerPOCs = useAppSelector(
    (state) => state.projectCustomerPOCs.allCustomerPOCs
  );

  return (
    <>
      {isValidArr(projectCustomerPOCs) ? (
        <Box mb={2}>
          <Typography
            variant="body1"
            sx={{ marginTop: "0.5em", fontWeight: "bold" }}
          >
            Customer POC Details:
          </Typography>
          <Divider />
          <Box pl="1em">
            {projectCustomerPOCs.map((customer) => (
              <Grid
                container
                mb={1}
                spacing={2}
                justifyContent="space-between"
                key={customer.id}
              >
                <Grid item xs={3}>
                  <Typography variant="subtitle2" sx={{ fontWeight: "bold" }}>
                    Name
                  </Typography>
                  <Typography variant="body2">{customer.name}</Typography>
                </Grid>
                <Grid item xs={3}>
                  <Typography variant="subtitle2" sx={{ fontWeight: "bold" }}>
                    Designation
                  </Typography>
                  <Typography variant="body2">
                    {customer.designation}
                  </Typography>
                </Grid>
                <Grid item xs={3}>
                  <Typography variant="subtitle2" sx={{ fontWeight: "bold" }}>
                    Email
                  </Typography>
                  <Typography variant="body2">{customer.emailId}</Typography>
                </Grid>
                <Grid item xs={3}>
                  <Typography variant="subtitle2" sx={{ fontWeight: "bold" }}>
                    Phone
                  </Typography>
                  <Typography variant="body2">
                    {customer.phoneNumber}
                  </Typography>
                </Grid>
              </Grid>
            ))}
          </Box>
        </Box>
      ) : null}
    </>
  );
};

export default CustomerPOCInfoSection;
